import User from '@/models/User';
import {
  clearLastActivity,
  clearRememberMe,
  isSessionStale,
  isTokenExpired,
  markSessionTimedOut,
} from '@/helpers/sessionTimeout';

export const CURRENT_USER_STORAGE_KEY = 'currentUser';

/**
 * שחזור הסשן מהאחסון - ועם הבדיקה שחסרה עד HAT-1092: סשן שהטוקן שלו פג, או
 * שנשאר ללא פעילות מעבר לזמן המותר, נגמר כאן ולא מוחזר כ"מחובר". הבדיקה חייבת
 * לקרות באתחול ה-state ולא ב-effect, אחרת המעטפת של האזור המחובר מהבהבת רגע
 * לפני ההפניה להתחברות.
 */
export const restoreUserFromStorage = (): User | null => {
  try {
    const storedUser = localStorage.getItem(CURRENT_USER_STORAGE_KEY);
    if (!storedUser) return null;

    const user: User = JSON.parse(storedUser);
    if (isTokenExpired(user?.token) || isSessionStale()) {
      localStorage.removeItem(CURRENT_USER_STORAGE_KEY);
      clearLastActivity();
      clearRememberMe();
      markSessionTimedOut();
      return null;
    }

    return user;
  } catch {
    return null;
  }
};
